import { Center } from 'src/design/atoms/Center';
import { Group } from 'src/design/atoms/Group';
import { Paper } from 'src/design/atoms/Paper';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import { Table } from 'src/design/molecules/Table';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MilestonePhaseDto } from 'src/api/FiretrolApiClient';
import { LinkButton } from 'src/design/atoms/LinkButton';

interface MilestoneCardProps {
  title: string;
  items: MilestonePhaseDto[];
  jobId: number;
}

export const MilestoneCard: React.FC<MilestoneCardProps> = ({
  title,
  items,
  jobId,
}) => {
  const navigate = useNavigate();

  const renderPhases = () => {
    if (items.length === 0) {
      return (
        <Center style={{ marginTop: '50px' }}>
          <Text>No Milestone Items</Text>
        </Center>
      );
    }

    const rows = items.map((phase) => {
      const total = phase.targetItems?.length ?? 0;
      const completed =
        phase.targetItems?.filter((i) => i.complete).length ?? 0;
      const percentage =
        total === 0 ? 0 : Math.trunc((completed / total) * 100);
      return (
        <Table.Tr key={phase.id}>
          <Table.Td>{phase.title}</Table.Td>
          <Table.Td style={{ textAlign: 'center' }}>
            {total - completed}
          </Table.Td>
          <Table.Td style={{ textAlign: 'center' }}>{percentage}%</Table.Td>
        </Table.Tr>
      );
    });

    return (
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Phase</Table.Th>
            <Table.Th style={{ textAlign: 'center' }}>Open Items</Table.Th>
            <Table.Th style={{ textAlign: 'center' }}>% Complete</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    );
  };

  return (
    <Paper>
      <Group justify="space-between" mb="md">
        <Title order={5}>{title}</Title>
        <LinkButton size="compact-xs" to={`/jobs/${jobId}/milestones`}>
          Open
        </LinkButton>
      </Group>
      <div style={{ height: 200, overflow: 'auto' }}>{renderPhases()}</div>
    </Paper>
  );
};
